jQuery(document).ready(function($){
    console.log("loading");
    
    $(document).on('click','#login_btn',function(e)
    {
        console.log("clicked");
        e.preventDefault();
        if(validateLoginForm())
        {
            console.log("if");
            $( "#login_form" ).submit();
        }      
    });
    $('.notifyDiv').delay(5000).fadeOut('slow');
    $('#customer_logout_link').on('click',function(e){
        e.preventDefault();
        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          success: function(){
             window.location.href =  '/account/logout';
          },
          dataType: 'json'
        });
    });
});

function validateLoginForm()
{
    var valid = true;
    var errMsg = {
        blank: "This field cannot blank",
        validMail: "This is not  valida email"
    };
    if($("#CustomerEmail").val() == '' || $("#CustomerEmail").val() == null)
    {
        $("#customer_email_err").html('<span class="input-error-message"><span class="visually-hidden">Erreur </span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z"></path></g></svg><span>E-mail ne peut pas rester vide.</span></span>');
        valid = false;
    }
    else
    {

        if(!$("#CustomerEmail").val().match(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/))
        {
            $("#customer_email_err").html('<span class="input-error-message"><span class="visually-hidden">Erreur </span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z"></path></g></svg><span>L `email n `est pas valide</span></span>');

            valid = false;
        }
        else
        {
            $("#customer_email_err").html("");
        }

    }

    if($("#CustomerPassword").val() == '' || $("#CustomerPassword").val() == null)
    {
        $("#customer_pwd_err").html('<span class="input-error-message"><span class="visually-hidden">Erreur </span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z"></path></g></svg><span>Le mot de passe ne peut pas être laissé vide.</span></span>');
        valid = false;
    }
    else
    {
        $("#customer_pwd_err").html("");
        $("#CustomerPassword").siblings('label').removeClass("text-error");
        $("#CustomerPassword").removeClass("has-error");
    }

    return valid;
}